import { SIG } from "../../common/apiUrl/sig/sigUrls";
import { API } from "../../common/model/objectTypes";
import { signatureStatusInfo } from "../../utils/apiDescription/sig/signatureStatus";
import { API_BASE_URL } from "../../utils/constants";
import { commonRequestHeader, commonResponseBody, createCommonJsonResponseWithData } from "../../utils/objectTypeConstants";
import { signatureStatusRequestBody } from "../../utils/sig/apiObject";
import { signatureStatusJsonRequestCurl } from "../../utils/sig/sampleJsonRequest";

const signatureStatus: API = {
    name: "Signature Status",
    url: `${API_BASE_URL}/${SIG.STATUS.SIGNATURE_STATUS_URL}`,
    method: "PUT",
    headers: commonRequestHeader,
    apiInfo: signatureStatusInfo.signatureStatus,
    requestBody: signatureStatusRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: signatureStatusJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(200),
}

export const getContent = (apiName: string) => {
    switch (apiName) {
        case 'Signature Status':
            return signatureStatus;
    }
}